import Table from './Table';

export * from './interface';

export default Table;



// WEBPACK FOOTER //
// ./components/table/index.tsx